import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class SectionCard extends Component {

    render() {
        const { headerClasses, header, body, id } = this.props;

        return (
            <div id={id} className="section-card-wrapper">
                <div className={"section-card-header-fold " + headerClasses}>
                    <div className="section-card-header-fold-dark">
                    </div>
                </div>
                <div className={"section-card-header " + headerClasses}>
                    { header }
                </div>
                <div className="section-card-body">
                    { body }
                </div>
            </div>
        );
    }
}

SectionCard.propTypes = {
    id: PropTypes.string,
    header: PropTypes.element.isRequired,
    headerClasses: PropTypes.string,
    body: PropTypes.element.isRequired,
};

export default SectionCard;